// AI-ASSISTED: generated with claude-code on 2026-06-10, reviewed by Yoann Hertienne
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useEntity } from '@backstage/plugin-catalog-react';
import { TileBoundary } from '../team-landing/TileBoundary';

const PROJECT_ANNOTATION = 'jira/project-key';
const COMPONENT_ANNOTATION = 'jira/component';
const JIRA_BASE = 'https://luminus.atlassian.net';

export const buildBoardUrl = (projectKey: string, jiraComponent?: string): string => {
  const jql = jiraComponent
    ? `project = ${projectKey} AND component = "${jiraComponent}" ORDER BY created DESC`
    : `project = ${projectKey} ORDER BY created DESC`;
  return `${JIRA_BASE}/issues/?jql=${encodeURIComponent(jql)}`;
};

const JiraCardBody = () => {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};
  const projectKey = annotations[PROJECT_ANNOTATION];
  const jiraComponent = annotations[COMPONENT_ANNOTATION];

  if (!projectKey) return null;

  return (
    <Card variant="outlined">
      <CardContent>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h6">Jira</Typography>
          <Stack direction="row" spacing={1}>
            <Chip size="small" label={`project: ${projectKey}`} />
            {jiraComponent && (
              <Chip size="small" variant="outlined" label={`component: ${jiraComponent}`} />
            )}
          </Stack>
        </Stack>
        <Typography variant="body2" color="text.secondary" sx={{ pt: 1 }}>
          Open the team's Jira board scoped to this component.
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          size="small"
          href={buildBoardUrl(projectKey, jiraComponent)}
          target="_blank"
          rel="noreferrer"
          aria-label="Open Jira board for this component"
        >
          Open in Jira
        </Button>
        <Button
          variant="text"
          size="small"
          href={`${JIRA_BASE}/jira/software/projects/${encodeURIComponent(projectKey)}/boards`}
          target="_blank"
          rel="noreferrer"
          aria-label="Open Jira project boards"
        >
          Project boards
        </Button>
      </CardActions>
    </Card>
  );
};

export const JiraCard = () => (
  <TileBoundary tool="Jira">
    <JiraCardBody />
  </TileBoundary>
);
